import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  getShoppingCartList: ({commit}, data) => {
    pointsMailApi.getShoppingCartList(data)
      .then(result => {
        commit(types.SHOPPING_CART_LIST, result)
      })
  },
  deleteCommodityById: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.deleteCommodityById(data)
        .then(result => {
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/shoppting-cart/store/actions.js